import { WebPlugin } from '@capacitor/core';
export class CapacitorPluginMlKitTextRecognitionWeb extends WebPlugin {
    // @ts-ignore
    detectText(options) {
        return Promise.reject("Web Plugin Not implemented");
    }
}
//# sourceMappingURL=web.js.map